import { action } from '@sas/nova-commons/action';
import { createReducer } from '../utils/action/createReducer';
const AT = {
    Update: 'manageColumns/update',
    NotifyUpdateDisplayedColumns: 'manageColumns/notifyUpdateDisplayedColumns',
};
export const ManageColumnsState = {
    elementName: 'manageColumns',
    actionTypes: AT,
    actions: {
        update: (data) => action(AT.Update, data),
        notifyUpdateDisplayedColumns: (data) => action(AT.NotifyUpdateDisplayedColumns, data),
    },
    reducer: createReducer({}, {
        [AT.Update](state, action) {
            return Object.assign(Object.assign({}, state), action.payload);
        },
        [AT.NotifyUpdateDisplayedColumns](state, _action) {
            return state;
        },
    }),
};
